export function formatCurrency(value: number | null | undefined) {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function formatNumber(value: number | null | undefined) {
  return new Intl.NumberFormat("nl-NL").format(Number(value || 0));
}

export function formatDate(value: string | null | undefined) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("nl-NL", { dateStyle: "medium" }).format(new Date(value));
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function formatDateTimeSeconds(value: string | null | undefined) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "medium",
    timeStyle: "medium",
  }).format(new Date(value));
}

export function displayName(first?: string | null, last?: string | null, company?: string | null, fallback?: string | null) {
  return company || [first, last].filter(Boolean).join(" ") || fallback || "Onbekende klant";
}
